import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vfzpdjf7u9: FaireBrandEntity = {
  token: "b_vfzpdjf7u9",
  type: "brand",
  name: "Pom Pom Popcorn by Bessou",
  avatarUrl:
    "https://cdn.faire.com/fastly/1b6e0db3c93071abdb36005569057c5206a7e97b7def0b1704d993f6f7cb525b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7ac29f9d898b89d57504698a5e16378ee266c4197b31a613ffc9430ecf7ddc70.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1b6e0db3c93071abdb36005569057c5206a7e97b7def0b1704d993f6f7cb525b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7ac29f9d898b89d57504698a5e16378ee266c4197b31a613ffc9430ecf7ddc70.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 70,
  rating: 4.8,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a NYC restaurant that's been sharing our love of Japanese flavors since 2016. Now we've created Japanese-flavored snacks using the most beloved of American munchies: POPCORN! \n\nIntroducing Pom Pom Popcorn.\n\nTaking our favorite childhood treats as inspiration, we use real ingredients in everything and make our popcorn in small batches so you can taste the love, care and flavor in every bite. The result is delightful, healthier snacking. Arigato!\n\n***\nOur Brand Values: \nGiving Back: A portion of our sales proceeds are donated to World Central Kitchen to help provide meals to those in need. \nCommunity for All: We are a woman-, Asian-American owned small business that is proud to create a diverse and inclusive work environment for employees of all genders and backgrounds.\nSmall Batch: We produce all of our popcorn in-house, by hand, in small batches. We are truly a small business!! \n\n***\nNote on Shipping: Please note that shipping costs on Faire are calculated by case, but for orders of anything above 1 case, we strive to decrease shipping costs for you by combining cases whenever possible. ",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:47.230Z",
    importedBy: "entity-db-cli",
  },
};
